import { Box, Button, CircularProgress, Grid, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import { useState } from 'react';
import SearchTxtField from '../../../components/SearchTxtField';
import { useAuthContext } from '../../../context/AuthContext';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { getComAddProdSrchServ } from '../../../services/com-service';
import { useEffect } from 'react';
import { customAlert } from '../../../components/notify';
import { AddCircle } from '@mui/icons-material';
import ScrollBox from '../../../components/ScrollBox';
import ProdCardBtn from '../../AmtcUser/AddProdToCompCatalog/ProdCardBtn';


function AddComProdMdl({ modalOpen, handleAddProdCardClick, handleModalClose }) {
    const theme = useTheme();
    const [searchWord, setSearchWord] = useState("")
    const { ctxtUser } = useAuthContext();
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
    const comId = ctxtUser?.comId;
    const [load, setLoad] = useState(true)
    const { isLoading, isError, error, data: prodData } = useQuery([QueryKey.getComAddProdSrch, comId, isSrchBtnClick],
        () => getComAddProdSrchServ({ comId, searchWord }), {
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoad(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    function onSearch(e) {
        setSearchWord(e.target.value)
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
    }

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal);
    }

    function handleAddProdClick(prodData) {
        handleAddProdCardClick(prodData)
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <Stack alignItems={"center"} gap={1} mb={1}>
                    <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)" }}>Add Product to Request</Typography>
                    <SearchTxtField handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} width={"70%"}
                        onBtnClick={onSearchBtnClick} placeholder="Enter the full 'AMTC Ref ID' to fetch the product." />
                </Stack>

                {
                    load ? <Stack width={"100%"} sx={{ alignItems: "center", justifyContent: "center", mt: "22.5%" }}>
                        <CircularProgress size={100} color={"primary"} />
                    </Stack> : <ScrollBox height={"78%"}>
                        <Grid container spacing={2}
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                                <ProdCardBtn i={i} key={i?.id} mt={0} icon={<AddCircle sx={{ color: "blue" }} type='com' />}
                                    handleProdClick={handleAddProdClick} /> </Grid>)}
                        </Grid>
                    </ScrollBox>}




            </Box>
        </Modal>
    )
}

export default AddComProdMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
    height: "60vh"
};